document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.playdate-waitlist').forEach(initWaitlist);
});

var PLAYDATE_CITIES = [
  'Adoni','Agartala','Agra','Ahmedabad','Ahmednagar','Aizawl','Ajmer','Akola','Aligarh','Alappuzha',
  'Allahabad','Alwar','Ambala','Amravati','Amritsar','Anand','Anantapur','Asansol','Aurangabad','Bagalkot',
  'Balasore','Bally','Bangalore','Bareilly','Bathinda','Belgaum','Bellary','Berhampur','Bhagalpur','Bharatpur',
  'Bharuch','Bhavnagar','Bhilai','Bhilwara','Bhiwandi','Bhopal','Bhubaneswar','Bidar','Bijapur','Bikaner',
  'Bilaspur','Bokaro','Burhanpur','Chandigarh','Chandrapur','Chennai','Chittoor','Coimbatore','Cuttack','Darbhanga',
  'Davanagere','Dehradun','Delhi','Deoghar','Dewas','Dhanbad','Dharwad','Dhule','Dibrugarh','Dindigul',
  'Durg','Durgapur','Eluru','Erode','Faizabad','Faridabad','Ferozepur','Firozabad','Gandhidham','Gandhinagar',
  'Gangtok','Gaya','Ghaziabad','Goa','Gorakhpur','Gulbarga','Guntur','Gurgaon','Guwahati','Gwalior',
  'Haldwani','Hapur','Haridwar','Hisar','Hospet','Hubli','Hyderabad','Imphal','Indore','Itanagar',
  'Jabalpur','Jaipur','Jalandhar','Jalgaon','Jalna','Jammu','Jamnagar','Jamshedpur','Jhansi','Jodhpur',
  'Junagadh','Kadapa','Kakinada','Kalyan','Kanchipuram','Kannur','Kanpur','Karimnagar','Karnal','Kochi',
  'Kohima','Kolar','Kolhapur','Kolkata','Kollam','Kota','Kottayam','Kozhikode','Kurnool','Latur',
  'Lucknow','Ludhiana','Madurai','Mangalore','Mathura','Meerut','Mehsana','Moradabad','Mumbai','Muzaffarnagar',
  'Muzaffarpur','Mysore','Nadiad','Nagercoil','Nagpur','Nanded','Nashik','Navi Mumbai','Nellore','Noida',
  'Ongole','Palakkad','Panaji','Panchkula','Panipat','Patiala','Patna','Pondicherry','Porbandar','Pune',
  'Raichur','Raipur','Rajahmundry','Rajkot','Ranchi','Ratlam','Rewa','Rohtak','Rourkela','Rudrapur',
  'Sagar','Saharanpur','Salem','Sambalpur','Sangli','Satara','Satna','Shillong','Shimla','Shimoga',
  'Sikar','Siliguri','Silvassa','Solapur','Sonipat','Srinagar','Surat','Thane','Thanjavur','Thiruvananthapuram',
  'Thoothukudi','Thrissur','Tiruchirappalli','Tirunelveli','Tirupati','Tiruppur','Udaipur','Udupi','Ujjain','Vadodara',
  'Varanasi','Vasai-Virar','Vellore','Vidisha','Vijayawada','Visakhapatnam','Warangal','Yamunanagar','Zirakpur'
];

function isFakePhone(phone) {
  if (/^(\d)\1{9}$/.test(phone)) return true;
  if (phone === '1234567890') return true;
  if (phone === '0123456789') return true;
  if (phone === '9876543210') return true;
  if (phone === '0987654321') return true;
  return false;
}

function isValidDob(dobStr) {
  var dob = new Date(dobStr);
  var today = new Date();
  if (dob > today) return false;
  var minDate = new Date();
  minDate.setFullYear(minDate.getFullYear() - 120);
  if (dob < minDate) return false;
  return true;
}

function isFakeEmail(email) {
  var parts = email.split('@');
  if (parts[0].length < 2) return true;
  var fakeDomains = ['test.com', 'example.com', 'fake.com', 'asdf.com', 'email.com'];
  var domain = parts[1] ? parts[1].toLowerCase() : '';
  if (fakeDomains.indexOf(domain) !== -1) return true;
  var typoTlds = ['.vom', '.con', '.comm', '.cim', '.ocm'];
  for (var i = 0; i < typoTlds.length; i++) {
    if (domain.slice(-typoTlds[i].length) === typoTlds[i]) return true;
  }
  return false;
}

function initWaitlist(section) {
  var openBtn = section.querySelector('[data-waitlist-open]');
  var modal = section.querySelector('[data-waitlist-modal]');
  var closeEls = section.querySelectorAll('[data-waitlist-close]');
  var card = section.querySelector('.waitlist-modal-card');
  var formView = section.querySelector('[data-waitlist-view="form"]');
  var successView = section.querySelector('[data-waitlist-view="success"]');
  var guardianSection = section.querySelector('[data-waitlist-guardian-section]');
  var dobInput = section.querySelector('[data-waitlist-dob]');
  var dobDisplay = section.querySelector('[data-waitlist-dob-display]');
  var cityInput = section.querySelector('[data-waitlist-city]');
  var cityDropdown = section.querySelector('[data-waitlist-city-dropdown]');
  var contentEl = section.querySelector('.waitlist-modal-content');

  if (!openBtn || !modal) return;

  function showError(name, message) {
    var el = section.querySelector('[data-waitlist-error="' + name + '"]');
    if (!el) return;
    el.textContent = message;
    el.style.display = 'block';
  }

  function clearErrors() {
    section.querySelectorAll('[data-waitlist-error]').forEach(function (el) {
      el.style.display = 'none';
      el.textContent = '';
    });
  }

  function openModal() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    formView.style.display = 'block';
    successView.style.display = 'none';
    card.classList.remove('is-success');
    clearErrors();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  openBtn.addEventListener('click', openModal);
  closeEls.forEach(function (el) {
    el.addEventListener('click', closeModal);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  // Allows a QR code or shared link (e.g. playdate.in/?waitlist=open) to
  // auto-open this modal on page load, without affecting the plain
  // homepage URL used for a general website QR.
  var urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('waitlist') === 'open') {
    openModal();
  }

  function renderCityOptions(filter) {
    cityDropdown.innerHTML = '';
    var matches = !filter ? PLAYDATE_CITIES : PLAYDATE_CITIES.filter(function (city) {
      return city.toLowerCase().indexOf(filter.toLowerCase()) === 0;
    });
    if (!matches.length) {
      cityDropdown.classList.remove('is-open');
      return;
    }
    matches.slice(0, 8).forEach(function (city) {
      var opt = document.createElement('div');
      opt.className = 'waitlist-city-option';
      opt.textContent = city;
      opt.addEventListener('click', function () {
        cityInput.value = city;
        cityDropdown.classList.remove('is-open');
      });
      cityDropdown.appendChild(opt);
    });
    cityDropdown.classList.add('is-open');
  }

  cityInput.addEventListener('input', function () { renderCityOptions(cityInput.value); });
  cityInput.addEventListener('focus', function () { renderCityOptions(cityInput.value); });
  cityInput.addEventListener('click', function () { renderCityOptions(cityInput.value); });

  document.addEventListener('click', function (e) {
    if (!cityInput.contains(e.target) && !cityDropdown.contains(e.target)) {
      cityDropdown.classList.remove('is-open');
    }
  });

  function calculateAge(dobStr) {
    var dob = new Date(dobStr);
    var today = new Date();
    var age = today.getFullYear() - dob.getFullYear();
    var m = today.getMonth() - dob.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) age--;
    return age;
  }

  var isUnder18 = false;

  function formatDobDisplay() {
    if (!dobInput.value) {
      dobDisplay.value = '';
      return;
    }
    var parts = dobInput.value.split('-');
    dobDisplay.value = parts[2] + '/' + parts[1] + '/' + parts[0];
  }

  dobInput.addEventListener('change', function () {
    formatDobDisplay();
    if (!dobInput.value) {
      guardianSection.style.display = 'none';
      isUnder18 = false;
      return;
    }
    var age = calculateAge(dobInput.value);
    isUnder18 = age < 18;
    guardianSection.style.display = isUnder18 ? 'block' : 'none';
  });

  dobDisplay.addEventListener('click', function () {
    if (dobInput.showPicker) {
      dobInput.showPicker();
    } else {
      dobInput.focus();
    }
  });

  var submitBtn = section.querySelector('[data-waitlist-submit]');

  submitBtn.addEventListener('click', function () {
    clearErrors();

    var name = section.querySelector('[data-waitlist-name]').value.trim();
    var email = section.querySelector('[data-waitlist-email]').value.trim();
    var phone = section.querySelector('[data-waitlist-phone]').value.trim();
    var dob = dobInput.value;
    var city = cityInput.value.trim();
    var consentMarketing = section.querySelector('[data-waitlist-consent-marketing]').checked;

    var hasError = false;

    if (!name) {
      showError('name', 'Please tell us what to call you.');
      hasError = true;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email) || isFakeEmail(email)) {
      showError('email', 'Please enter a valid email address.');
      hasError = true;
    }
    if (!/^\d{10}$/.test(phone) || isFakePhone(phone)) {
      showError('phone', 'Please enter a valid phone number.');
      hasError = true;
    }
    if (!dob || !isValidDob(dob)) {
      showError('dob', 'Please enter a valid date of birth.');
      hasError = true;
    }
    if (!city) {
      showError('city', 'Please enter your city.');
      hasError = true;
    }

    var gName, gEmail, gPhone, consentGuardian;

    if (isUnder18) {
      gName = section.querySelector('[data-waitlist-guardian-name]').value.trim();
      gEmail = section.querySelector('[data-waitlist-guardian-email]').value.trim();
      gPhone = section.querySelector('[data-waitlist-guardian-phone]').value.trim();
      consentGuardian = section.querySelector('[data-waitlist-consent-guardian]').checked;

      if (!gName) {
        showError('guardian-name', 'Please enter the parent/guardian name.');
        hasError = true;
      }
      if (gEmail && (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(gEmail) || isFakeEmail(gEmail))) {
        showError('guardian-email', 'Please enter a valid email address.');
        hasError = true;
      }
      if (gPhone && (!/^\d{10}$/.test(gPhone) || isFakePhone(gPhone))) {
        showError('guardian-phone', 'Please enter a valid phone number.');
        hasError = true;
      }
      if (!consentGuardian) {
        showError('guardian-consent', 'Please confirm you are the parent or legal guardian.');
        hasError = true;
      }
    }

    if (hasError) {
      var visibleErrors = Array.prototype.filter.call(
        section.querySelectorAll('[data-waitlist-error]'),
        function (el) { return el.style.display === 'block'; }
      );
      if (visibleErrors.length) {
        visibleErrors[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }

    var state = {
      name: name, email: email, phone: '+91' + phone, dob: dob, city: city,
      consentMarketing: consentMarketing,
      guardianName: isUnder18 ? gName : '',
      guardianEmail: isUnder18 ? gEmail : '',
      guardianPhone: isUnder18 && gPhone ? '+91' + gPhone : '',
      consentGuardian: isUnder18 ? consentGuardian : false
    };

    submitWaitlist(state);
  });

  function submitWaitlist(state) {
    fetch('https://script.google.com/macros/s/AKfycbxuaHxtAM_YZIbfR0LuFwcf3LafZzFvJClILYZcI87Vq3L1wglWNH-4KHUpgORXnhEE/exec', {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify({
        type: 'waitlist',
        name: state.name,
        email: state.email,
        phone: state.phone,
        dob: state.dob,
        city: state.city,
        consentMarketing: state.consentMarketing,
        guardianName: state.guardianName,
        guardianEmail: state.guardianEmail,
        guardianPhone: state.guardianPhone,
        consentGuardian: state.consentGuardian
      })
    }).catch(function () {
      // Silently fail, don't block the success view if this errors
    });

    formView.style.display = 'none';
    successView.style.display = 'block';
  }
}